var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVmware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "VMware Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vmware-cls-1{fill:#f18b21;}.vmware-cls-2,.vmware-cls-4,.vmware-cls-7,.vmware-cls-8{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.01px;}.vmware-cls-2{stroke:#f08d21;}.vmware-cls-3{fill:#0597d3;}.vmware-cls-4{stroke:#0597d3;}.vmware-cls-5{fill:#c86f29;}.vmware-cls-6{fill:#0877a9;}.vmware-cls-7{stroke:#0877a9;}.vmware-cls-8{stroke:#c86f29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "            "
  }, /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-1",
    d: "M141.69,103a18,18,0,0,1,12.62,12.62v36.06h28.54v0h4.39v-.07h.41V90.36q-4.92-16-20.8-20.84H39.09q-15.89,4.86-20.8,20.84V219q4.92,16,21.25,20.2H166.4q16.33-4.23,21.25-20.2V185.44H154.31v8.07a17.17,17.17,0,0,1-12.88,12.25H64.55a17.17,17.17,0,0,1-12.88-12.25V115.59A18,18,0,0,1,64.29,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-2",
    d: "M64.55,205.76a17.17,17.17,0,0,1-12.88-12.25V115.59A18,18,0,0,1,64.29,103h77.4a18,18,0,0,1,12.62,12.62v36.06m33.34-.11V90.36q-4.92-16-20.8-20.84H39.09q-15.89,4.86-20.8,20.84V219q4.92,16,21.25,20.2H166.4q16.33-4.23,21.25-20.2V185.44m-33.34,0v8.07a17.17,17.17,0,0,1-12.88,12.25h.86m-78.64,0h77.78M38.09,239.17h1.45m126.86,0h1.45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": "            "
  }, /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-3",
    d: "M242,36.81q-4.92-16-20.81-20.84H93.46q-15.88,4.87-20.8,20.84V69.52H106V62a18,18,0,0,1,12.62-12.61H196A18,18,0,0,1,208.64,62V140a17.15,17.15,0,0,1-12.88,12.25H118.88A17.15,17.15,0,0,1,106,140V103H72.66v62.45q4.91,16,21.25,20.21H220.77q16.33-4.24,21.25-20.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-4",
    d: "M72.66,103v62.45q4.91,16,21.25,20.21H220.77q16.33-4.24,21.25-20.21V36.81q-4.92-16-20.81-20.84H93.46q-15.88,4.87-20.8,20.84V69.52m33.34,0V62a18,18,0,0,1,12.62-12.61H196A18,18,0,0,1,208.64,62V140a17.15,17.15,0,0,1-12.88,12.25h.89m-77.77,0H118M106,103v37a17.15,17.15,0,0,0,12.88,12.25h76.88M93.91,185.63H92.46m129.76,0h-1.45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": "  "
  }, /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-5",
    d: "M187.65,199.73V185.44l-31.45.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-6",
    d: "M72.66,103.91V117.3l31.82-13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-7",
    d: "M104.48,103.76,72.66,117.3V103.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vmware-cls-8",
    d: "M156.2,185.63l31.45,14.1V185.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmware);
export default __webpack_public_path__ + "static/media/Vmware.b64e2773d258082b30bb569751fce5be.svg";
export { ForwardRef as ReactComponent };